//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const fallback = {
  nombre: null,
  correo: null,
  celular: null,
  desarrollo: null,
  comentarios: null,
  curp: null,
}

export default {
  props: {
    prospecto: {
      required: true,
      type: Object,
      default() {
        return fallback
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
}
